import projectUtils from "../../../../../../utils/project-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";
import {format, isValid, parse} from "date-fns";
import {ptBR} from "date-fns/locale/pt-BR";

function formatDate(date){
  if(!date) return "";
  const parsedDate = parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());

  if(!isValid(parsedDate)) return date;

  return format(parsedDate, 'dd/MM/yyyy HH:mm', { locale: ptBR });
}

export function generateDispatchList(data) {
  const headers = ["ID", "D/H inicial", "Dia da semana", "D/H final", "ID do atendimento", "Telefone", "Solicitante", "Status", "Bo de terceiro",
    "Natureza", "Grupo de natureza", "Local pré-cadastrado","Logradouro", "Bairro", "Classe de guarnição", "Quantidade de deslocamento", "Apoio", "Flagrante",
    "Ato infracional", "Dano ao patrimônio público", "Despacho não encontrado"];
  const rows = data.map(item => [
    item.dispatch_id,
    formatDate(item.dt_start),
    item.dow,
    formatDate(item.dt_end),
    item.attendance_id,
    projectUtils.formatPhone(item.phone),
    item.contact_name,
    item.bo_and_status,
    item.thyrd_bo,
    item.nature,
    item.nature_group,
    item.place_name,
    item.street_name,
    item.neighborhood_name,
    item.garrison_class,
    item.displacement_qty,
    item.support_garrison,
    item.flagrant,
    item.infracional_act,
    item.public_patrimony,
    item.not_found,
  ]);

  data?.length && ReportUtils.createExportableTable(headers, rows, "Lista de despachos");
}